<template>
  <el-dialog :title="null"  :close-on-click-modal="false" :show-close="false" custom-class="poster-dialog" :visible.sync="visible" width="22%" center>
    <div class="order-scan-poster-container" ref="orderScanPosterContainer" id="orderScanPosterContainer">
      <!-- 外层框架 -->
      <div class="order-scan-outer-frame">
        <!-- 内层内容区 -->
        <div class="order-scan-inner-content">
          <!-- 顶部标题区 -->
          <div class="order-scan-header">
            <div class="order-scan-title">瑞通达物流</div>
            <div class="order-scan-subtitle">以下货源信息最终解释权归瑞通达物流APP所有</div>
          </div>

          <!-- 内容边框 -->
          <div class="order-scan-content-frame">
            <!-- 背景图 -->
            <img :src="backgroundImage" class="order-scan-background-image" alt="背景图" crossOrigin="anonymous" />

            <!-- 内容遮罩 -->
            <div class="order-scan-content-overlay">
              <!-- 路线信息 -->
              <div class="order-scan-route-info">
                <div class="order-scan-route-container">
                  <!-- 起始地 -->
                  <div class="order-scan-location order-scan-start">
                    <div class="order-scan-place">{{ share.takeRoute || '' }}</div>
                    <div class="order-scan-time">{{ share.takeTime || '' }}</div>
                  </div>

                  <!-- 运输线 -->
                  <div class="order-scan-transport-line">
                    <div class="order-scan-transport-type">{{ share.entranceTypeName || '' }}</div>
                    <div class="order-scan-line"></div>
                    <div class="order-scan-transport-type">{{ share.orderTypeName || '' }}</div>
                  </div>

                  <!-- 目的地 -->
                  <div class="order-scan-location order-scan-end">
                    <div class="order-scan-place">{{ share.giveRoute || '' }}</div>
                    <div class="order-scan-time">{{ share.giveTime || '' }}</div>
                  </div>
                </div>
              </div>

              <!-- 分隔线 -->
              <div class="order-scan-divider"></div>

              <!-- 订单车型 -->
              <div class="order-scan-info-section">
                <div class="order-scan-info-title">🚗订单车型</div>
                <div class="order-scan-info-content">{{ share.vehicleInfo || '' }}</div>
              </div>

              <!-- 里程时效 -->
              <div class="order-scan-info-section">
                <div class="order-scan-info-title">🚩里程时效</div>
                <div class="order-scan-info-content">{{ (share.distance || '') + ' | ' + (share.duration || '') }}</div>
              </div>

              <!-- 货物信息 -->
              <div class="order-scan-info-section">
                <div class="order-scan-info-title">💼货物信息</div>
                <div class="order-scan-info-content">{{ share.goods || '' }}</div>
              </div>

              <!-- 备注信息 -->
              <div class="order-scan-info-section">
                <div class="order-scan-info-title">🔥备注</div>
                <div class="order-scan-info-content order-scan-remark">{{ share.remark || '' }}</div>
              </div>
            </div>
          </div>

          <!-- 底部推荐区 -->
          <div class="order-scan-footer">
            <div class="order-scan-footer-content">
              <div class="order-scan-text-content">
                <div class="order-scan-footer-text">你好，我是深圳市瑞通达物流有限公司</div>
                <div class="order-scan-recommend-title">
                  <span>为你推荐</span>
                  <span class="order-scan-highlight">好货源</span>
                </div>
                <div class="order-scan-qr-code-text">
                  <span>长按识别二维码</span>
                  <span class="order-scan-action-text">立即接单</span>
                </div>
              </div>
              <div class="order-scan-qr-code-container">
                <img :src="share.qrCode" class="order-scan-qr-code" alt="二维码" crossOrigin="anonymous" />
              </div>
            </div>
          </div>

          <!-- 温馨提醒区 -->
          <div class="order-scan-root-container">
            <div class="order-scan-step-wrapper">
              <div class="order-scan-step-text-container">
                <span class="order-scan-step-text">
          操作步骤:识别二维码->进入小程序->去接单->前往装货地确认->确认到达装货地并拍照->确认装货完成并拍照->确认到达卸货地->确认卸货完成并拍照->完结(如有代垫费用(停车费、过磅费等)，请在费用上报处录入并拍照上传小票)
        </span>
              </div>
            </div>
            <div class="order-scan-tips-container">
              <span class="order-scan-tips-text">
        温馨提示: 订单只有在完结后会自动推送至财务端进行费用审核结算，否则影响运费结算与信誉评级
      </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-row style="text-align: -webkit-center;margin-top: 10px">
      <el-col :span="12"><div class="grid-content bg-purple"><el-button size="mini" type="danger" @click="() => visible = false" >关闭海报</el-button></div></el-col>
      <el-col :span="12"><div class="grid-content bg-purple"><el-button size="mini" type="success" @click="savePoster" >分享海报</el-button></div></el-col>
    </el-row>
    <el-row style="text-align: -webkit-center;margin-top: 10px">
      <el-col :span="12"><div class="grid-content bg-purple"><el-button size="mini" type="primary" @click="copyPoster">分享海报文本</el-button></div></el-col>
      <el-col :span="12"><div class="grid-content bg-purple"><el-button size="mini" type="info" :disabled="!rowOrder.vehiclePlan" @click="copyDriverPoster">分享司机文本</el-button></div></el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import {call} from "runjs/lib/script";

const conversionKilometer = (distance) => {
  if (!distance) {
    return 0
  }
  return Number.isInteger(distance * 0.001) ? distance * 0.001 : parseFloat((distance  * 0.001).toFixed(2))
}
const secondsToHoursMinutes = (seconds) => {
  if (!seconds) {
    return '0时0分'
  }
  // 计算小时数（向下取整）
  const hours = Math.floor(seconds / 3600);
  // 计算剩余的分钟数
  const minutes = Math.floor((seconds % 3600) / 60);

  // 返回格式化的字符串
  return `${hours}时${minutes}分`;
}
import html2canvas from 'html2canvas';
import {getClone} from "@/utils/myJsonClone";
export default {
  components: {},
  data() {
    return {
      visible: false,
      backgroundImage: 'https://rtd-tms.oss-cn-shenzhen.aliyuncs.com/10000/rtd/tms/annex/qrCode/055SharpBlues.png',
      domain: '',
      share: {},
      rowOrder: {},
      list: []
    }
  },
  computed: {},
  created() {
    let that = this
    that.$http({
      url: that.$http.adornUrl('/sys/appConfig/get'),
      method: 'get',
      params: that.$http.adornParams({ type: 2 })
    }).then(({ data }) => {
      this.domain = JSON.parse(data.configValue).spaceDomain
    })
  },
  methods: {
    async init(orderRow,dataListRow) {
      this.share = {};
      this.rowOrder = {};
      this.list = []
      let orderV = await getClone(orderRow);
      let listV = await getClone(dataListRow);
      const loading = this.$loading({
        lock: true,
        text: '正在生成海报图片，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });

      // 生成司机端二维码
      this.$http({
        url: this.$http.adornUrl('/social/obtainTheDriverEndMiniProgramCodeBasedOnTheOrderId'),
        method: 'get',
        params: this.$http.adornParams({ orderId: orderV.orderInfo.id, type: 0 })
      }).then(({ data }) => {
        if (data) {
          let orderTypeName = '专车'
          if (orderV.orderInfo.orderType && orderV.orderInfo.orderType == 2) {
            orderTypeName = '拼车'
          } else if (orderV.orderInfo.orderType && orderV.orderInfo.orderType == 3) {
            orderTypeName = '零担'
          }
          // 处理
          this.share = {
            companyName: orderV.orderInfo.customerName,
            takeRoute: ((orderV.cityNode).replace(/省|市|区/g, '')) + ((orderV.areaNode).replace(/省|市|区/g, '')),
            takeTime: orderV.deliveryTimeNode,
            giveRoute: ((orderV.giveAddressInfo.city).replace(/省|市|区/g, '')) + ((orderV.giveAddressInfo.area).replace(/省|市|区/g, '')),
            giveTime: orderV.abortWarehouseTimeNode,
            goods: (orderV.orderGoods.goodsName ? orderV.orderGoods.goodsName : '') + ' | ' + (orderV.orderGoods.packTypeName ? orderV.orderGoods.packTypeName : ''),
            distance: conversionKilometer(orderV.orderInfo.distance) + ' km',
            duration: secondsToHoursMinutes(orderV.orderInfo.duration),
            remark: orderV.orderInfo.remark,
            qrCode: this.domain + data,
            vehicleInfo: (orderV.vehicleTypeNameNode ? orderV.vehicleTypeNameNode : '') + (orderV.orderInfo.isTailstock && orderV.orderInfo.isTailstock == 1 ? ' | ' + '有尾板' : ''),
            entranceTypeName: orderV.orderInfo.entranceTypeName ? orderV.orderInfo.entranceTypeName : '一般贸易',
            orderTypeName: orderTypeName,
          }
          this.rowOrder = orderV
          this.list = listV
          this.visible = true;
        } else {
          this.$message.error('生成海报错误!')
        }
      }).catch((err) => {
        console.error('生成海报错误',err)
        this.$message.error('生成海报错误')
      }).finally(() => {
        loading.close()
      })
    },
    async savePoster() {
        const element = this.$refs.orderScanPosterContainer;
        try {
          // 3. 生成canvas
          const canvas = await html2canvas(element, {
            backgroundColor: null,
            scale: 2, // 提高清晰度
            logging: false,
            useCORS: true // 允许跨域图片
          });
          // 转换为blob
          canvas.toBlob(async (blob) => {
            try {
              // 使用Clipboard API复制图片
              await navigator.clipboard.write([
                new ClipboardItem({
                  [blob.type]: blob
                })
              ]);
              this.$message.success('海报已复制到剪贴板');
            } catch (err) {
              this.$message.error('海报分享失败,请手动截取')
            }
          });
        } catch (err) {
          this.$message.error('海报分享失败,请手动截取')
        }
      // 唤起微信
      await this.activateWechat()
    },
    async copyPoster() {
      const formattedTextV = `提货日期: ${this.share.takeTime}
提货点: ${this.share.takeRoute ? this.share.takeRoute : ''}
卸货点: ${this.share.giveRoute ? this.share.giveRoute : ''}
订单车型：${this.share.vehicleInfo ? this.share.vehicleInfo : ''}
货物信息:  ${this.share.goods ? this.share.goods : ''}
里程时效:  ${this.share.distance ? this.share.distance : ''} | ${this.share.duration ? this.share.duration : ''}
备注：${this.share.remark ? this.share.remark : ''}`;
      try {
        await navigator.clipboard.writeText(formattedTextV);
        this.$message.success('分享成功,已复制到粘贴板!')
      } catch (e) {
        this.$message.error('复制文本失败')
      }

      // 唤起微信
      await this.activateWechat()

    },
    async copyDriverPoster() {
      let row = this.rowOrder;
      if (row.vehiclePlan) {
        // 提货和送货
        let id = row.orderInfo.id;
        let rows = this.list.filter(x => {
          if (x.orderInfo && x.orderInfo.id == id) {
            return true
          } else {
            return false
          }
        })
        let rowsStr = ''
        rows.forEach(x => {
          rowsStr += '提货点: ' +  (x.cityNode ? x.cityNode : '') + (x.areaNode ? x.areaNode : '') + '\n' + '卸货点: ' + (x.giveAddressInfo.city ? x.giveAddressInfo.city : '') + (x.giveAddressInfo.area ? x.giveAddressInfo.area : '') + '\n-----------------------------\n'
        })

        // 复制剪贴板
        const formattedText = `提货时间：${row.deliveryTimeNode ? row.deliveryTimeNode : ''}
深圳市瑞通达物流有限公司
姓名：${row.vehiclePlan.driverName}
电话:  ${row.vehiclePlan.driverPhone}
身份证：${row.vehiclePlan.driverCard}
车牌及车型：${row.vehiclePlan.vehiclePlate} / ${row.vehiclePlan.vehicleTypeName}
车重：${row.vehiclePlan.vehicleEmptyWeight ? row.vehiclePlan.vehicleEmptyWeight + 'KG' : ''}
${rowsStr} `;
        try {
          await navigator.clipboard.writeText(formattedText);
          this.$message.success('分享成功,已复制到粘贴板!')
        } catch (e) {
          this.$message.error('复制失败')
        }

        // 唤起微信
        await this.activateWechat()
      }
    },
    async activateWechat() {
      const loading = this.$loading({
        lock: true,
        text: '正在唤起微信，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 尝试唤起微信
      try {
        window.location.href = `weixin:`
      } catch (e) {
        this.$message.error('唤起微信失败')
      } finally {
        loading.close()
      }
    }
  },
}
</script>

<style scoped>
.order-scan-poster-container {
  width: 100%;
  margin: 0 auto;
}

.order-scan-outer-frame {
  margin-top: 10px;
  background: linear-gradient(to top, #dfe9f3 0%, white 100%);
  border-radius: 15px;
  padding: 2.5px;
  border: 0.5px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
  0 3px 8px rgba(0, 0, 0, 0.1),
  0 6px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  overflow: hidden;
}

.order-scan-inner-content {
  padding: 7.5px;
  height: 100%;
}

.order-scan-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 5px;
}

.order-scan-header .order-scan-title {
  font-size: 12.5px;
  font-weight: 600;
  color: #333;
  margin-left: 2px;
}

.order-scan-header .order-scan-subtitle {
  font-size: 9px;
  color: #aaa;
  text-align: right;
}

.order-scan-content-frame {
  border-radius: 15px;
  overflow: hidden;
  height: 43vh;
  position: relative;
}

.order-scan-background-image {
  border-radius: 15px;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.order-scan-content-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 5px;
  color: white;
}

.order-scan-route-info {
  margin-bottom: 9px;
}

.order-scan-route-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.order-scan-location {
  padding: 8px;
}

.order-scan-location .order-scan-place {
  display: block;
  font-size: 17.5px;
  font-weight: bold;
  color: #FAFAFA;
  margin-bottom: 3px;
}

.order-scan-location .order-scan-time {
  display: block;
  font-size: 11px;
  color: #bdbdbd;
}

.order-scan-transport-line {
  width: 95px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 10px;
  justify-content: center;
}

.order-scan-transport-type {
  font-size: 13px;
  color: #FAFAFA;
  margin: 2.5px 0;
}

.order-scan-transport-line .order-scan-line {
  width: 100%;
  height: 1px;
  background-color: #ccc;
  margin: 4px 0;
}

.order-scan-divider {
  height: 0.5px;
  width: 100%;
  background-color: #ccc;
  margin: 4px 0;
}

.order-scan-info-section {
  margin-bottom: 1px;
  margin-left: 2.5px;
}

.order-scan-info-title {
  font-size: 12.5px;
  font-weight: bold;
  color: #bdbdbd;
}

.order-scan-info-content {
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  font-weight: bold;
  margin-left: 5px;
}

.order-scan-remark {
  word-wrap: break-word;
  max-width: 275px;
}

.order-scan-footer {
  box-shadow: 0 -2px 4px rgba(0,0,0,0.02);
  padding: 8px;
}

.order-scan-footer-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.order-scan-text-content {
  flex: 1;
  padding-right: 15px;
}

.order-scan-footer-text {
  display: block;
  font-size: 11px;
  color: #666;
  letter-spacing: 0.25px;
  margin-bottom: 6px;
}

.order-scan-recommend-title {
  display: flex;
  align-items: baseline;
  margin-bottom: 10px;
}

.order-scan-recommend-title span {
  font-family: "KaiTi", "STKaiti", serif;
  font-size: 21px;
  font-weight: bold;
  color: #333;
  letter-spacing: 1px;
  text-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.order-scan-recommend-title .order-scan-highlight {
  font-size: 24px;
  color: #e74c3c;
  margin-left: 5px;
  position: relative;
}

.order-scan-qr-code-text {
  display: flex;
  align-items: center;
}

.order-scan-qr-code-text span {
  font-size: 13px;
  color: #666;
  letter-spacing: 0.25px;
}

.order-scan-qr-code-text .order-scan-action-text {
  font-size: 13px;
  font-weight: bold;
  color: #e74c3c;
  margin-left: 6px;
  padding: 3px 8px;
  background: rgba(231,76,60,0.1);
  border-radius: 10px;
  border: 0.5px solid rgba(231,76,60,0.3);
}

.order-scan-qr-code-container {
  width: 80px;
  height: 80px;
}

.order-scan-qr-code {
  width: 100%;
  height: 100%;
  object-fit: contain;
}


.order-scan-root-container {
  border-radius: 12rpx;
  padding: 10rpx;
  margin: 10rpx 0;
}
.order-scan-step-wrapper {}
.order-scan-step-text-container {
  margin-bottom: 8rpx;
}
.order-scan-step-text {
  font-size: 14rpx;
  color: #d35400;
  /* 文本过长时自动换行 */
  white-space: normal;
}
.order-scan-tips-container {
  display: flex;
  align-items: center;
  margin-bottom: 15rpx;
}
.order-scan-tips-text {
  font-size: 14rpx;
  font-weight: bold;
  color: #d35400;
  white-space: normal;
}
</style>

<style>
/* 全局覆盖el-dialog样式 */
.poster-dialog {
  background: transparent !important;
  box-shadow: none !important;
}

.poster-dialog .el-dialog__header {
  display: none !important;
}

.poster-dialog .el-dialog__body {
  padding: 0 !important;
  background: transparent !important;
}
</style>
